const colors = {
    available: '#6FA132',
    comingSoon: '#F47822',
    relaunched: '#007DC1',
    notAvailable: '#C1C1C1',
};

export default colors;
